import { useSelector } from 'react-redux';
import { entriesSelector } from "../../store/selectors/entities/entries";
import { subSheetsSelector } from "../../store/selectors/entities/sheets";
export const LABELS_ABOVE_SCREEN_TYPE_ID = 11;
export const LABELS_LEFT_SCREEN_TYPE_ID = 10;
export const LOOP_SCREEN_TYPE_ID = 15;
export const ADVANCED_LOOP_SCREEN_TYPE_ID = 13;
const getSheetEntries = id => {
  const allEntries = useSelector(entriesSelector);
  return allEntries.filter(({
    sheet_id
  }) => sheet_id === id);
};
export const getSubSheetScreens = ({
  subSheets,
  ...sheet
}) => {
  const sheets = useSelector(subSheetsSelector);
  return subSheets.map(subSheetId => {
    const subSheet = sheets.find(({
      id
    }) => subSheetId == id);
    const entries = getSheetEntries(subSheetId);
    return {
      sheet,
      subSheet,
      entries
    };
  });
};
const getStandardScreenEntries = sheet => {
  const entries = getSheetEntries(sheet.id);
  return [{
    sheet,
    entries
  }];
};
export const getScreenEntries = sheet => {
  const {
    sheet_type_id
  } = sheet;
  const screenMethods = {
    15: getSubSheetScreens,
    default: getStandardScreenEntries
  };
  const populate = screenMethods[sheet_type_id] || screenMethods['default'];
  return populate(sheet);
};
export const getKeyField = sheet => getSheetEntries(sheet.id)[0];
export const prepareScreen = sheet => ({
  keyField: getKeyField(sheet),
  screens: getScreenEntries(sheet)
});